import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import ErrorCard from 'components/@common/ErrorCard';

const useStyles = makeStyles(() => {
  return {
    root: {
      height: '100%',
      background: '#eee'
    }
  };
});

const ErrorPage = (): React.ReactElement => {
  const classes = useStyles();

  return (
    <Grid container justify="center" alignItems="center" className={classes.root}>
      <ErrorCard />
    </Grid>
  );
};

export default ErrorPage;
